import { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Caption, FormTips, Title4 } from '../../../styles/TypoStyle';
import { Insurance, insuranceByCode, InsuranceModel } from '../../../utils/InsuranceModel';
import { formatAmount, formatTaux } from '../../../utils/NumberFormatter';
import { ScoreProps } from '../../../utils/ResponsePageModel';

const RowData = styled(FormTips)`
  font-weight: var(--typo-title4-font-weight);
  padding: 8px 0px 6px 0px;
  &.two-lines-row-data {
    padding: 15px 0px 6px 0px;
  }
`;
const RowTitle = styled(Caption)`
  flex: 1;
  padding: 10px 0px 8px 0px;
`;
const Container = styled.div`
  padding: 20px 10px;
  base-card {
    margin: 0px;
  }
`;

const SeparatorLine = styled.div`
  border-top: 1px solid;
  border-color: var(--neutrals-50);
  padding: 0px;
`;

const Title = styled(Title4)`
  line-height: var(--typo-title3-font-size);
  text-align: center;
  margin-bottom: 30px;
  //tablet or larger
  @media (min-width: 496px) {
    padding: 0px 35px;
    font-size: var(--typo-title3-font-size);
    line-height: 28px;
  }
`;

const InsuranceTitle = styled(Caption)`
  font-weight: bold;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 0px;

  &.insurance-data-first-row {
    margin-top: 36px;
    margin-bottom: 8px;
  }
  &.insurance-row {
    margin-top: 16px;
  }
  &.insurance-data-last-row {
    margin-bottom: 24px;
  }
`;

const InsuranceDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  base-card-separator {
    padding: 0px 16px;
  }
  //tablet or larger
  @media (min-width: 496px) {
    base-card-separator {
      padding: 0px 32px;
    }
  }
`;
const LoanDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px 20px;
  //tablet or larger
  @media (min-width: 496px) {
    margin: 8px 16px;
  }
`;

const DataTable: FunctionComponent<ScoreProps> = ({ score }): ReactElement => {
  const [asm, setAsm] = useState<InsuranceModel>();

  useEffect(() => {
    if (score?.holderAsmCode && score?.holderAsmCode !== undefined && score?.holderAsmCode !== '0')
      setAsm(insuranceByCode(score?.holderAsmCode as unknown as Insurance));
  }, [score]);

  return (
    <Container>
      {/* <BaseCard> */}
      <LoanDataContainer>
        <Title>Voici votre offre</Title>
        {/* <Title>
          {formatAmount(
            score?.creditMonthlyPaymentWithoutInsurance ? score?.creditMonthlyPaymentWithoutInsurance : 0.0,
          ) + '/mois'}
        </Title> */}
        <Row className="first-row">
          <RowTitle>Montant du crédit</RowTitle>
          <RowData>{formatAmount(score?.creditAmount ? score?.creditAmount : 0.0)}</RowData>
        </Row>
        <Row>
          <RowTitle>
            Mensualité <br></br>(hors assurance facultative)
          </RowTitle>
          <RowData>
            {formatAmount(
              score?.creditMonthlyPaymentWithoutInsurance ? score?.creditMonthlyPaymentWithoutInsurance : 0.0,
            )}
          </RowData>
        </Row>
        <Row>
          <RowTitle>Nombre de mensualités</RowTitle>
          <RowData>{score?.term} mensualités</RowData>
        </Row>
        <Row>
          <RowTitle>Taux débiteur fixe</RowTitle>
          <RowData>{formatTaux(score?.tnc ? score?.tnc : 0.0)}</RowData>
        </Row>
        <Row>
          <RowTitle>TAEG fixe</RowTitle>
          <RowData>{formatTaux(score?.taeg ? score?.taeg : 0.0)}</RowData>
        </Row>
        <Row>
          <RowTitle>Intérêts</RowTitle>
          <RowData>{formatAmount(score?.interestAmount ? score?.interestAmount : 0.0)}</RowData>
        </Row>

        {/*
          <SeparatorLine></SeparatorLine>
          <Row>
            <RowTitle>Nombre de mensualités</RowTitle>
            <RowData>{score?.term} mensualités</RowData>
          </Row> */}

        <Row>
          <RowTitle>Frais de dossier</RowTitle>
          <RowData>{formatAmount(score?.feeAmount ? score?.feeAmount : 0.0)}</RowData>
        </Row>
        <Row className="loan-data-last-row">
          <RowTitle>
            Montant total dû <br></br>(hors assurance facultative)
          </RowTitle>
          <RowData className="two-lines-row-data">
            {formatAmount(score?.totalCreditAmountWithoutInsurance ? score?.totalCreditAmountWithoutInsurance : 0.0)}
          </RowData>
        </Row>
      </LoanDataContainer>
      {/* {score?.holderAsmCode !== '0' && (
          <InsuranceDataContainer slot="separator">
            <BaseCardSeparator title="Votre assurance">
              <Row className="insurance-data-first-row">
                <InsuranceTitle>
                  {asm?.label}
                  <Caption> ({asm?.code})</Caption>
                </InsuranceTitle>
              </Row>
              <Row className="insurance-row">
                <RowTitle>Coût mensuel de l’assurance facultative</RowTitle>
                <RowData>
                  {formatAmount(score?.holderInsuranceMonthlyPayment ? score?.holderInsuranceMonthlyPayment : 0.0)}
                </RowData>
              </Row>
              <SeparatorLine className="insurance-row"></SeparatorLine>
              <Row className="insurance-row">
                <RowTitle>Coût total de l’assurance facultative</RowTitle>
                <RowData>
                  {formatAmount(score?.holderInsuranceTotalCost ? score?.holderInsuranceTotalCost : 0.0)}
                </RowData>
              </Row>
              <SeparatorLine className="insurance-row"></SeparatorLine>
              <Row className="insurance-data-last-row">
                <RowTitle>Taux annuel effectif de l’assurance</RowTitle>
                <RowData>{formatTaux(score?.taea ? score?.taea : 0.0)}</RowData>
              </Row>
            </BaseCardSeparator>
          </InsuranceDataContainer>
        )} */}
      {/* </BaseCard> */}
    </Container>
  );
};

export default DataTable;
